import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.64 6.422c-1.359-1.36-1.359-3.656 0-5.063a3.594 3.594 0 0 1 5.016 0l.844.844.797-.844a3.594 3.594 0 0 1 5.015 0c1.36 1.407 1.36 3.704 0 5.063l-4.78 4.875a1.45 1.45 0 0 1-1.032.422c-.422 0-.797-.14-1.078-.422zm18.985 9.375c.61.844.422 2.015-.422 2.625l-5.906 4.36A6.54 6.54 0 0 1 16.5 24h-15A1.48 1.48 0 0 1 0 22.5v-3c0-.797.656-1.5 1.5-1.5h1.688l2.109-1.687A6.1 6.1 0 0 1 9.047 15H16.5c.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5h-3.75c-.422 0-.75.375-.75.75 0 .422.328.75.75.75h5.625L24 15.375a1.877 1.877 0 0 1 2.625.422M9.047 18H9z"
    }, null, -1)
  ]))]))
}
export default { render: render }